import React, { useState } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
// @material-ui/icons components

// core components
import StatsHeader from "components/Headers/StatsHeader.js";
import CardSalesValue from "components/Cards/Dashboard/CardSalesValue.js";
import CardTotalOrders from "components/Cards/Charts/CardTotalOrders.js";

import componentStyles from "assets/theme/views/admin/dashboard.js";
import componentStylesCardDeck from "assets/theme/components/cards/card-deck.js";
import { useAsyncEffect } from "use-async-effect";
import { redirectToLogout } from "common/SharedFn";
import {
  getMonthlyStats,
  getPosStats,
  getPosMonthlyStats,
} from "network/ApiAxios";

const useStyles = makeStyles(componentStyles);
const useStylesCardDeck = makeStyles(componentStylesCardDeck);

function Dashboard() {
  const classes = { ...useStyles(), ...useStylesCardDeck() };
  const [data, setData] = useState([]);
  const [posMonthly, setPosMonthly] = useState([]);
  const [posStats, setPosStats] = useState(null);
  // "app" (default) shows the app figures; "pos" shows walk-in POS figures.
  const [view, setView] = useState("app");
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [showError, setShowError] = React.useState(false);
  const [success, setSuccess] = React.useState(false);

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const fetchMonthlyStats = async () => {
    setIsLoading(true);
    try {
      const response = await getMonthlyStats();
      const { data } = response;
      if (data.result.isSuccess) {
        setData(data.data.reverse());
      } else {
        showErrorNotification(data.result.description);
        if (data.result.code == -2) {
          redirectToLogout();
        }
      }
    } catch (ex) {
      showErrorNotification("Failed to fetch statistics");
    }
    setIsLoading(false);
  };

  // POS (walk-in) figures. Loaded quietly alongside the app stats; if the tenant
  // has no POS data (hasData=false) the App/POS toggle simply never appears.
  const fetchPosStats = async () => {
    try {
      const [statsRes, monthlyRes] = await Promise.all([
        getPosStats(),
        getPosMonthlyStats(),
      ]);
      if (statsRes.data.result.isSuccess) {
        setPosStats(statsRes.data.data);
      }
      if (monthlyRes.data.result.isSuccess) {
        setPosMonthly((monthlyRes.data.data || []).reverse());
      }
    } catch (ex) {
      // POS is optional; a failure here just leaves the page app-only.
    }
  };

  useAsyncEffect(async () => {
    fetchMonthlyStats();
    fetchPosStats();
  }, []);

  const posHasData = !!(posStats && posStats.hasData);
  const graphData = view === "pos" ? posMonthly : data;

  return (
    <>
      <StatsHeader
        section="Default"
        subsection="Dashboards"
        showViewToggle={posHasData}
        view={view}
        onViewChange={setView}
        posStats={posStats}
      />
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-6rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12} xl={6} classes={{ root: classes.gridItemRoot }}>
            <CardSalesValue stats={graphData} />
          </Grid>
          <Grid item xs={12} xl={6}>
            <CardTotalOrders stats={graphData} />
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default Dashboard;
